export interface ADResults {
  airports: ADAirport[]
}

export interface ADAirport {
  airportCode: string
  airportName: string
  arrivals: ADDelay
  departures: ADDelay
}

export enum ADDelay {
  OnTime,
  Delay,
  MajorDelay
}
